/**
 * SuperBrain Referral Landing Redirect
 * /r/:code — stores the referral code and forwards to the homepage
 * © 2026 A-1 Affiliate Marketing LLC
 */

import React, { useEffect, useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;

const ReferralRedirect = () => {
  const { code } = useParams();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const run = async () => {
      try {
        const upper = (code || '').toUpperCase();
        localStorage.setItem('sb_ref_code', upper);
        // Fire-and-forget validate (purely to log; we still store the code either way)
        await axios.get(`${API}/referrals/validate/${upper}`).catch(() => {});
      } finally {
        setReady(true);
      }
    };
    run();
  }, [code]);

  if (!ready) {
    return (
      <div style={{
        background: '#0A0E1A', color: '#C8860A', minHeight: '100vh',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontFamily: 'Georgia, serif'
      }} data-testid="referral-redirect">
        Applying your referral code...
      </div>
    );
  }
  return <Navigate to={`/?ref=${encodeURIComponent(code || '')}`} replace />;
};

export default ReferralRedirect;
